import { EncounterPayload } from '_api/types';
import dayjs from 'dayjs';

const DefaultEncounter: EncounterPayload = {
  patient_id: 0,
  hours: '',
  minutes: '',
  date_of_observation: dayjs().format('MM/DD/YYYY'),
  interactionOccurred: false,
};

export default DefaultEncounter;
